import React, { useState, useEffect } from "react";
import NavMain from "../components/nav/NavMain";
import HeaderLoan from "../components/header/HeaderLoan";
import { useParams } from "react-router-dom";
import axios from "axios";
import GLOBALVAR from "../constants";
import { format } from 'date-fns';
import { Container, Col, Row, Button, Modal } from "react-bootstrap";
import EditLoan from "../components/modals/EditLoan";
import { useNavigate } from 'react-router-dom';
import DueDates from "../components/misc/DueDates";
import ToPeso from "../components/misc/ToPeso";

function LoanPage() {
    const { id } = useParams();
    const [loan, setLoan] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [showModalDeletePayment, setShowModalDeletePayment] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const handleCloseDelete = () => setShowModalDelete(false);
    const handleShowDelete = () => setShowModalDelete(true);
    const handleCloseDeletePayment = () => setShowModalDeletePayment(false);
    const handleShowDeletePayment = () => setShowModalDeletePayment(true);
    const navigate = useNavigate();
    const [paymentList, setPaymentList] = useState(null);
    const [payment, setPayment] = useState(null);

    const fetchLoan = async (id) => {
        try {
            const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/${id}`);
            const loanData = response.data;
            setPaymentList(loanData.payments);
            setLoan(loanData);
        } catch (error) {
            console.error('Error fetching loan:', error);
        }
    };

    const handleDeleteProcess = async(id) => {
        if (!id) {
            return;
        }
        
        try {
            await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/delete/${id}`);
            navigate('/');
        } catch (error) {
            console.error('Error deleting loan:', error);
        }
    };

    const handleDeleteProcessPayment = async(id) => {
        if (!payment) {
            return;
        }
        
        try {
            await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/payments/delete/${payment}`);
            window.location.reload();
        } catch (error) {
            console.error('Error deleting payment:', error);
        }
    };

    const updateParentLoan = (newLoanData) => {
        setLoan(newLoanData);
    };

    useEffect(() => {
        fetchLoan(id);
    }, [id]);

    return (
        <>
            <Modal show={showModal} onHide={handleClose} className="edit-loan-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Loan Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EditLoan loanProcessingData={loan} updateParentLoanProcessing={updateParentLoan} />
                </Modal.Body>
            </Modal>
            <Modal show={showModalDelete} onHide={handleCloseDelete}>
                <Modal.Header closeButton>
                    <Modal.Title className="h6">Are you sure you want to delete this loan?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center">
                        <Button variant="primary" className="me-2" onClick={handleCloseDelete}>No</Button>
                        <Button variant="warning" onClick={() => handleDeleteProcess(loan ? loan.id : null)}>Yes</Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={showModalDeletePayment} onHide={handleCloseDeletePayment} className="delete-loan-modal">
                <Modal.Header closeButton>
                    <Modal.Title className="h6">Are you sure you want to delete this payment?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center">
                        <Button variant="primary" className="me-2" onClick={handleCloseDeletePayment}>No</Button>
                        <Button variant="warning" onClick={() => handleDeleteProcessPayment(payment ? payment : null)}>Yes</Button>
                    </div>
                </Modal.Body>
            </Modal>
            <NavMain />
            <HeaderLoan loan={loan} />
            <div className="main-content loan-page">
                <div className="quick-links">
                    <Button variant="primary" onClick={handleShow}><i className="fa-solid fa-pencil"></i> Edit Details</Button>
                    <Button variant="warning" onClick={handleShowDelete}><i className="fa-solid fa-trash"></i> Send to Trash</Button>
                    <Button variant="primary" href={`/add-repayment/?id=${id}`}><i className="fa-solid fa-credit-card"></i> Add Payment</Button>
                    <Button variant="primary" href={`/applicant/${loan ? loan.applicant.id : null}`}><i className="fa-regular fa-circle-user"></i> Applicant Page</Button>
                </div>
                <Container className="parent-container">
                    <Row>
                        <Col className="loan-details">
                            {loan && (
                            <>
                                <Row>
                                    <Col className="title">Loan Processing Type</Col>
                                    <Col className="value">{loan.loanProcessingType}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Amount Granted</Col>
                                    <Col className="value"><ToPeso amount={loan.amountGranted} /></Col>
                                </Row>
                                <Row>
                                    <Col className="title">Net Amount</Col>
                                    <Col className="value"><ToPeso amount={loan.amountGranted - (loan.serviceFee + loan.notarialFee + loan.docStamp + loan.insurance)} /></Col>
                                </Row>
                                <Row>
                                    <Col className="title">Date Granted</Col>
                                    <Col className="value">{format(new Date(loan.dateGranted), 'MM/dd/yyyy')}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Interest Rate</Col>
                                    <Col className="value">{loan.interestRate}%</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Loan Term</Col>
                                    <Col className="value">{loan.loanTerm}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Payment Type</Col>
                                    <Col className="value">{loan.paymentType}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Loan Interval</Col>
                                    <Col className="value">{loan.loanInterval}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Service Fee</Col>
                                    <Col className="value"><ToPeso amount={loan.serviceFee} /></Col>
                                </Row>
                                <Row>
                                    <Col className="title">Notarial Fee</Col>
                                    <Col className="value"><ToPeso amount={loan.notarialFee} /></Col>
                                </Row>
                                <Row>
                                    <Col className="title">Doc Stamp</Col>
                                    <Col className="value"><ToPeso amount={loan.docStamp} /></Col>
                                </Row>
                                <Row>
                                    <Col className="title">Insurance</Col>
                                    <Col className="value"><ToPeso amount={loan.insurance} /></Col>
                                </Row>
                                <Row>
                                    <Col className="title">Account Officer</Col>
                                    <Col className="value">{loan.accountOfficer}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Loan Product</Col>
                                    <Col className="value">{loan.loanProduct}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Loan Ledger</Col>
                                    <Col className="value">{loan.loanLedger}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Loan Security</Col>
                                    <Col className="value">{loan.loanSecurity}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Reference</Col>
                                    <Col className="value">{loan.reference}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Loan Type</Col>
                                    <Col className="value">{loan.loanType}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Additional Beneficiary</Col>
                                    <Col className="value">{loan.addtl_beneficiary}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Additional Contact</Col>
                                    <Col className="value">{loan.addtl_contact}</Col>
                                </Row>
                                <Row>
                                    <Col className="title">Additional Relationship</Col>
                                    <Col className="value">{loan.addtl_relationship}</Col>
                                </Row>
                            </>
                            )}
                        </Col>
                        <Col>
                            <div className="payment-duedates">
                                {loan && (
                                    <>
                                    <h1>Payment Due Dates ({loan.loanInterval})</h1>
                                    <DueDates date={loan.dateGranted} interval={loan.loanInterval} term={loan.loanTerm} amount={loan.amountGranted} interest={loan.interestRate} paymentList={paymentList} />
                                    </>
                                )}
                            </div>
                            <div className="payment-list">
                                <h1>Payment History</h1>
                                {paymentList && (
                                    <>
                                    {paymentList.map((item, index) => {
                                        return (
                                            <div className="payment-list__item" key={index}>
                                                <div className="payment-list__item-details">
                                                    <div className="payment-list__item-paymentdate"><i className="fa-solid fa-calendar-days"></i> {format(new Date(item.paymentDate), 'MMM dd, yyyy')}</div>
                                                    <div className="payment-list__item-paymenttype">
                                                        <span className="paymenttype">{item.paymentType}</span>
                                                        {item.paymentType === "cheque" && (
                                                            <>
                                                            <div className="payment-list__item-paymenttype-cheque"><label>Cheque Number:</label> {item.chequeNumber}</div>
                                                            </>
                                                        )}
                                                    </div>
                                                    <div className="payment-list__item-btns">
                                                        <Button variant="warning" 
                                                        onClick={()=>{
                                                            handleShowDeletePayment();
                                                            setPayment(item.id);
                                                        }}
                                                        ><i className="fa-solid fa-trash"></i> Delete</Button>
                                                    </div>
                                                </div>
                                                <div className="payment-list__item-totals">
                                                    <label>Payment Total:</label> <ToPeso amount={item.paidTotal} />
                                                    <ul>
                                                        <li>Principal: <span><ToPeso amount={item.paidPrincipal} /></span></li>
                                                        <li>Interest: <span><ToPeso amount={item.paidInterest} /></span></li>
                                                        <li>Penalty: <span><ToPeso amount={item.paidPenalty} /></span></li>
                                                        <li>Other: <span><ToPeso amount={item.paidOther} /></span></li>
                                                    </ul>
                                                </div>
                                                <div className="payment-list__item-numbers">
                                                    {item.prNumber && (
                                                        <>
                                                        <div className="payment-list__item-number"><label>PR Number:</label> {item.prNumber}</div>
                                                        </>
                                                    )}

                                                    {item.orNumber && (
                                                        <>
                                                        <div className="payment-list__item-number"><label>OR Number:</label> {item.orNumber}</div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                    </>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default LoanPage;
